<template>
  <div>

    <p v-if="pax">
      <strong>pax</strong>
      <pre>{{ pax }}</pre>
    </p>

    <p v-if="user_request['messages']">
      <strong>messaggi</strong>
      <pre>{{ user_request['messages'] }}</pre>
    </p>
    <p>
      <strong>customer</strong>
      <pre>{{ user_request['request-customer'] }}</pre>
    </p>
    <p>
      <strong>guests</strong>
      <pre>{{ user_request['request-guests'] }}</pre>
    </p>
    <p>
      <strong>pernottamenti</strong>
      <pre>{{ user_request['request-overnights'] }}</pre>
    </p>
    <p>
      <strong>trattamenti</strong>
      <pre>{{ user_request['request-treatment'] }}</pre>
    </p>
    <p>
      <strong>voli</strong>
      <pre>{{ user_request['request-flights'] }}</pre>
    </p>
    <p>
      <strong>interessi</strong>
      <pre>{{ user_request['request-interests'] }}</pre>
    </p>
    <p>
      <strong>transfers</strong>
      <pre>{{ user_request['request-transfers'] }}</pre>
    </p>
    <!--<p>
        <strong>generici</strong>
        <pre>{{ user_request['request-tours'] }}</pre>
    </p>-->
    <p>
      <strong>assicurazioni</strong>
      <pre>{{ user_request['request-insurances'] }}</pre>
    </p>
    <p>
      <strong>budget</strong>
      <pre>{{ user_request['request-budget'] }}</pre>
    </p>
  </div>
</template>
<script>

export default {
  name: 'user-request',
  components: {
  },
  props: {
    user_request: Object,
    pax: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
    }
  },
  computed: {
  },
  created()
  {
  },
  mounted() {

  },
  methods:{

  },
}
</script>

<style lang="scss">

</style>
